import { useAuthStore, useSiteStatusStore } from '@/stores';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { mainDomain } from './variables';
import { Router } from 'vue-router';

export default async function setupInterceptors(router: Router) {
    const store = useAuthStore();
    const statusStore = useSiteStatusStore();
    axios.interceptors.response.use(
        (response: AxiosResponse) => {
            const { data } = response;
            if (data && data.error) {
                if (data?.error === 6000) {
                    if (data.redirect_url === `https://${mainDomain}/blocked`) {
                        router.push('/blocked');
                    } else if (data.redirect_url) {
                        window.location.href = data.redirect_url;
                    }
                    statusStore.toSetSiteStatus('blocked', true);
                    return Promise.reject('Blocked');
                } else if (data?.error === 6001) {
                    router.push('/maintenance');
                    statusStore.toSetSiteStatus('maintenance', true);
                    return Promise.reject('Maintenance');
                }
            }
            return response;
        },
        (error: AxiosError) => {
            if (error.response?.status === 401) {
                store.signOut();
            }
            return Promise.reject(error);
        }
    );
}
